import { useEffect } from 'react';

import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { useIsMobile } from '@hooks/use-is-mobile';

import { Box } from 'components/Box';
import { CreateUserButton } from 'components/CreateUserButton';
import { Header } from 'components/headers';
import { SearchBoxInput } from 'components/SearchBox';
import { SearchButton } from 'components/SearchButton';
import { Spacer } from 'components/Spacer';
import { useAuthenticatedUser } from 'features/authentication';
import { useStore } from 'models/Provider';

import { TeamList } from './TeamList';

export const Team = observer(() => {
  const { userStore, t } = useStore();
  const me = useAuthenticatedUser();

  useEffect(() => {
    if (me.role === 'admin' || me.role === 'superadmin') {
      userStore.loadFollowerStats();
    }
  }, [userStore, me.role]);

  return (
    <>
      <Header
        breadcrumbs={<TeamBreadCrumbs />}
        actions={<TeamActions />}
        mobileTitle={t('navigation.settings.team')}
      />

      <TeamList />
    </>
  );
});
export default Team;

const TeamBreadCrumbs = observer(() => {
  const { t } = useStore();
  return <Breadcrumb items={[{ label: t('navigation.settings.team') }]} />;
});

const TeamActions = observer(() => {
  const { uiSettings, t } = useStore();
  const isMobile = useIsMobile();
  const settings = uiSettings.team;

  if (!isMobile) {
    return (
      <TeamActionsContainer>
        <SearchButton
          value={settings.searchStr}
          onChange={settings.setSearchValue}
          clear={settings.clearSearchValue}
          isOpen={settings.searchOpen}
          onClose={settings.closeSearch}
          onOpen={settings.openSearch}
          placeholder={t('user.search.tip')}
        />
        <Spacer left={8}>
          <CreateUserButton />
        </Spacer>
      </TeamActionsContainer>
    );
  }
  return (
    <div style={{ width: '100%' }}>
      <CreateUserButton fullWidth />
      <Box mt="16">
        <SearchBoxInput
          placeholder={t('user.search.tip')}
          value={settings.searchStr}
          onChange={settings.setSearchValue}
        />
      </Box>
    </div>
  );
});

const TeamActionsContainer = styled.div((p) => ({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-end',
}));
